import React, { useContext, useEffect, useState } from "react";
// import "./Edit_User_Modal.css";
import { Button, Form, Modal } from "react-bootstrap";
import Modal_Heading from "../../Common_Component/Modal_Heading/Modal_Heading";
import Edit_User_Modal_Frame from "../../Common_Component/Common_Modal/Edit_User_Modal/Edit_User_Modal_Frame/Edit_User_Modal_Frame";
import { Update, findOne } from "../../../utils/apis/master/avatars/index";
import { Controller, useForm } from "react-hook-form";
import classNames from "classnames";
import { HTTPS } from "../../../utils/common";
import { Context } from "../../../utils/context";
import ModalSave from "../../Common_Component/Common_Modal/Successfull_Modal/ModelSave";
import Select from "react-select";
function Edit(props) {
  const { UnauthorizedLogOut, IMG_URL } = useContext(Context);
  const id = props.show;
  const [showModal, setShowModal] = useState({
    code: 0,
    message: "",
  });

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
    setError,
    watch,
    getValues,
    control,
  } = useForm();
  const imageFile = watch("image");
  const onSubmit = async (data) => {
    try {
      const sendData = new FormData();
      
      sendData.append("image", data?.image[0]);
      const result = await Update(id, sendData);
      const response = result.data;

      if (HTTPS.ALREADY_REPORTED.code !== response?.code) {
        await setShowModal({
          code: response.code,
          message: response.data,
        });

        setTimeout(() => {
          setShowModal(0);
          props.onHide();
        }, 1000);
      } else {
        setError("name", {
          message: response?.errors?.name?.msg,
        });
      }
    } catch (error) {
      setError("name", {
        type: "manual", // Optional but helps to indicate it's a manual error
        message: error?.response?.data?.errors,
      });
      await UnauthorizedLogOut(error);
      console.error(error.message);
    }
  };

  const GetEditData = async () => {
    if (id) {
      const response = await findOne(id);
      reset(response?.data?.data);
    }
  };
  useEffect(() => {
    GetEditData();
  }, [id]);

  const [UsersType, setUsersType] = useState([
    {
      value: "customers",
      label: "customers",
      name: "users_type",
    },
    {
      value: "agents",
      label: "agents",
      name: "users_type",
    },
  ]);

  return (
    <>
      <section>
        <Modal
          {...props}
          className="Edit_User_Modal modal_holder"
          size="md"
          aria-labelledby="contained-modal-title-vcenter"
          centered
        >
          <Modal_Heading modalHeading={"Edit Avatar"} />
          <div className="modal-body-holder">
            {/* <Edit_User_Modal_Frame /> */}
            <Modal.Body>
              <div className="main-form-holder">
                <Form className="form-holder" onSubmit={handleSubmit(onSubmit)}>
                  <div className="row">
                    
                    <div className="col-md-12 col-sm-12 mt-3">
                      <Form.Group
                        className="form-field"
                        controlId="formBasicEmail"
                      >
                        <Form.Label>Image*</Form.Label>
                        <Form.Control
                          className={classNames("", {
                            "is-invalid": errors?.image,
                          })}
                          type="file"
                          {...register("image", {
                            validate: async (value) => {
                              if (typeof value !== "string") {
                                const fileTypes = ["jpg", "png", "jpeg"];
                                const fileType = value[0].name?.split(".")[1];
                                if (!fileTypes.includes(fileType)) {
                                  return `please upload a valid file format. (${fileTypes})`;
                                }
                                // const sizes = await getDimension(value[0]);
                                // if (sizes.width !== 800 && sizes.height !== 400) {
                                //   return "Image width and height must be 800 px and 400  px";
                                // }
                                // const fileSize = Math.round(value[0].size / 1024);
                                // if (fileSize > 500) {
                                //   return "file size must be lower than 500kb";
                                // }
                              }
                            },
                          })}
                          accept=".jpg, .jpeg, .png"
                        />
                        {errors.image && (
                          <span className="text-danger">
                            {errors.image.message}
                          </span>
                        )}
                      </Form.Group>
                    </div>
                    <div className="col-md-12 col-sm-12 mt-3 mb-3">
                      <Form.Label className="text-center">
                        Image Preview
                      </Form.Label>
                      {typeof getValues("image") == "string" ? (
                        <div className="image-preview-container">
                          <img
                            src={IMG_URL + getValues("image")}
                            alt="Preview"
                            className="image-preview"
                            style={{ width: "150px", height: "130px" }}
                          />
                        </div>
                      ) : (
                        imageFile &&
                        imageFile?.length > 0 && (
                          <div className="image-preview-container">
                            <img
                              // src={URL.createObjectURL(getValues("image")[0])}
                              src={URL?.createObjectURL(imageFile[0])}
                              alt="Preview"
                              className="image-preview"
                              style={{ width: "100px", height: "100px" }}
                            />
                          </div>
                        )
                      )}
                    </div>
                  </div>
                </Form>

                <div className="modal-footer-holder">
                  <div className="d-flex justify-content-center align-items-center">
                    <Button
                      className="search-btn mx-2"
                      onClick={() => {
                        props.onHide();
                        reset();
                      }}
                    >
                      Cancel
                    </Button>

                    <Button
                      className="reset-btn mx-2"
                      type="button"
                      onClick={handleSubmit(onSubmit)}
                    >
                      Submit
                    </Button>
                  </div>
                </div>
              </div>
            </Modal.Body>
          </div>
        </Modal>
        <ModalSave
          message={showModal.message}
          showErrorModal={showModal.code ? true : false}
        />
      </section>
    </>
  );
}

export default Edit;
